import { Duration, type DurationUnit } from '@/lib/duration';

export type AvgSessionDurationUnit = Extract<DurationUnit, 'seconds' | 'minutes' | 'hours'>;

export const AVG_SESSION_DURATION_UNIT_OPTIONS: { value: AvgSessionDurationUnit; label: string }[] = [
  { value: 'seconds', label: 'seconds' },
  { value: 'minutes', label: 'minutes' },
  { value: 'hours', label: 'hours' },
];

const SECONDS_IN_HOUR = Duration.from({ hours: 1 }).toUnit('seconds');
const SECONDS_IN_MINUTE = Duration.from({ minutes: 1 }).toUnit('seconds');

export function inferDurationUnit(seconds: number): AvgSessionDurationUnit {
  if (seconds > 0 && seconds % SECONDS_IN_HOUR === 0) return 'hours';
  if (seconds > 0 && seconds % SECONDS_IN_MINUTE === 0) return 'minutes';
  return 'seconds';
}

export function convertDurationUnitToSeconds(value: number, unit: AvgSessionDurationUnit): number {
  return Duration.convert(value, { from: unit, to: 'seconds' });
}

export function convertSecondsToDurationUnit(seconds: number, unit: AvgSessionDurationUnit): number {
  return Duration.convert(seconds, { from: 'seconds', to: unit });
}
